import { Stack, Typography } from "@mui/material";
import React from "react";
import StepPaymentItem from "./StepPaymentItem/StepPaymentItem";
import { useTranslation } from "react-i18next";

const BoletoPaymentPrice4 = ({ visible }: { visible: boolean }) => {
    const { t } = useTranslation();

    return (
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ display: visible ? undefined : "none" }}>
            <StepPaymentItem
                src="/assets/icons/payments/ticket/date.svg"
                title={t("checkout.boleto.step1Title")}
                subtitle={t("checkout.boleto.step1Text")}
            />
            <StepPaymentItem
                src="/assets/icons/payments/ticket/timer.svg"
                title={t("checkout.boleto.step2Title")}
                subtitle={t("checkout.boleto.step2Text")}
            />
            <StepPaymentItem
                src="/assets/icons/payments/ticket/pix.svg"
                title={t("checkout.boleto.step3Title")}
                subtitle={t("checkout.boleto.step3Text")}
            />
        </Stack>
    );
};

export default BoletoPaymentPrice4;
